import { render, staticRenderFns } from "./ExamesHivSifilis.vue?vue&type=template&id=5803fa3e"
import script from "./ExamesHivSifilis.vue?vue&type=script&lang=js"
export * from "./ExamesHivSifilis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports